import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useBookAddNewAlias, useSearchBookByIdentifiers } from '@/module/Author/Book/model/BookQuery';
import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { bookMembershipOptions } from '@/module/Nomen/BookMembership/model/BookMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function BookSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(bookMembershipOptions.getAll());

  const mutation = useBookAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { bookId: publicationId, request: request },
      {
        onSuccess: book => {
          notification.success();
          navigate({ to: '/author/book/$bookId', params: { bookId: String(book.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      useSearchPublicationHook={useSearchBookByIdentifiers}
      includeIsbn
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
